module.exports = __webpack_public_path__ + "static/media/(DH)_MG_6295_-_Joias_Contenporaneas.a84d3ad2.jpg";